import { AppSettingsProvider } from "~context/AppSettingsContext/AppSettingsContext.tsx";
import { UserPermissionsProvider } from "~context/UserPermissionsContext";
import { UserUpdatesProvider } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { Content } from "./components/Content/Content.tsx";
import { Header } from "./components/Header/Header.tsx";
import { MenuDrawer } from "./components/MenuDrawer/MenuDrawer.tsx";
import "./Layout.scss";

export const Layout = () => (
  <div className="app-layout">
    <AppSettingsProvider>
      <UserUpdatesProvider>
        <UserPermissionsProvider>
          <Header />
          <MenuDrawer />
          <Content />
        </UserPermissionsProvider>
      </UserUpdatesProvider>
    </AppSettingsProvider>
  </div>
);
